export const commentModalState = {
  open: false,
  form: {
    sender_name: null,
    sender_email: null,
    sender_position: null,
    sender_phone: null,
    accept: false,
    comment: null,
  },
  error: [],
  modal: {
    personal: false,
    comment: false,
  },
  title: '',
  pdErrors: null,
};

export type PdErrors = {
  comment: string[];
  pd_name: string[];
  pd_email: string[];
  pd_phone: string[];
  pd_position: string[];
};

export type CommentModalState = Omit<typeof commentModalState, 'pdErrors'> & {
  pdErrors: PdErrors;
};

export type CommentModalForm = CommentModalState['form'];
